import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[tunPopupContent]',
    standalone: false
})
export class PopupContentDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
